/**
 * EDGEFleet: fills the contact form with the article a visitor asked about.
 *
 * The "Angebot anfordern" button on a "Preis auf Anfrage" product (see
 * snippets/price-on-request-button.liquid) links here with `?produkt=` and `&link=`.
 * Reading them in the browser rather than in Liquid is deliberate: Shopify's full-page
 * cache ignores unknown query parameters, so the contact page is served from cache no
 * matter which article the visitor came from.
 *
 * Only an empty message field is filled — a value restored after a failed submit, or one
 * the visitor already typed, always wins.
 */

const CONFIG_SELECTOR = 'script[type="application/json"][data-contact-request-prefill]';
const FIELD_SELECTOR = 'textarea[name="contact[body]"]';

function readTemplate() {
  const config = document.querySelector(CONFIG_SELECTOR);
  if (!config) return '';

  try {
    return JSON.parse(config.textContent) || '';
  } catch {
    return '';
  }
}

function prefill() {
  const params = new URLSearchParams(window.location.search);
  const productTitle = params.get('produkt');
  if (!productTitle) return;

  const template = readTemplate();
  if (!template) return;

  const message = template
    .replaceAll('[Produkt]', productTitle)
    .replaceAll('[Link]', params.get('link') ?? '');

  for (const field of document.querySelectorAll(FIELD_SELECTOR)) {
    if (field.value.trim() !== '') continue;
    field.value = message;
  }
}

prefill();
